/* eslint-disable @typescript-eslint/no-unused-vars */

/* eslint-disable jsx-a11y/anchor-has-content */

/* eslint-disable jsx-a11y/anchor-is-valid */
import { DownCircleOutlined } from '@ant-design/icons';
import { Modal } from 'antd';
import { billingSelectors } from 'containers/App/selectors';
import { resetHospitalCPAP } from 'pages/BillingProcess/slices';
import { getHospitalByCPAP } from 'pages/BillingProcess/thunk';
import React, { useState, useImperativeHandle } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TablePatient from './TablePatient';
import './styles';

type Props = {
  props?: any;
  ref?: any;
};

const ModalPatient = React.forwardRef((props, ref) => {
  const dispatch = useDispatch();
  const { hospitalForCpap } = useSelector(billingSelectors);
  const [modalVisible, setModalVisible] = useState<boolean>(false);
  const [page, setPage] = useState(1);
  const [cpapId, setCpapId] = useState('');
  const [patientName, setPatientName] = useState('');
  useImperativeHandle(ref, () => {
    return {
      openModal: (cpap_id: string, patientName: string) => {
        dispatch(getHospitalByCPAP({ cpap_id: cpap_id, page: 1 }));
        setModalVisible(true);
        setCpapId(cpap_id);
        setPatientName(patientName);
      },
      closeModal: () => {
        setModalVisible(false);
      },
    };
  });

  const handleChangePage = (page: number) => {
    dispatch(getHospitalByCPAP({ cpap_id: cpapId, page: page }));
    setPage(page);
  };

  return (
    <Modal
      centered
      visible={modalVisible}
      onOk={() => setModalVisible(false)}
      onCancel={() => {
        dispatch(resetHospitalCPAP);
        setModalVisible(false);
      }}
      okButtonProps={{ style: { display: 'none' } }}
      cancelText="閉じる"
      width={817}
    >
      <p className="extraLargeFont">
        {patientName} <span className="standardBoldFont">さんの直近の受診履歴</span>
      </p>
      <TablePatient />
      {hospitalForCpap?.totalItems &&
        hospitalForCpap?.totalItems > 12 &&
        hospitalForCpap.items.length < hospitalForCpap?.totalItems && (
          <div className="standardFont" style={{ marginTop: '15px', display: 'flex', justifyContent: 'flex-end' }}>
            <a style={{ color: '#80a450' }} onClick={() => handleChangePage(page + 1)}>
              さらに履歴を表示 <DownCircleOutlined />
            </a>
          </div>
        )}
    </Modal>
  );
});
export default ModalPatient;
